//#region src/type.ts
const PriorityChannel = {
	TurboModePriority: 500,
	HighPriority: 1e3,
	XHighPriority: 1500
};
const ParametersDefaults = {
	width: 512,
	height: 512,
	samplingSteps: 28,
	samplingMethod: "Euler a",
	priority: PriorityChannel.HighPriority,
	strength: .7,
	upscale: 1,
	batchSize: 1,
	enableTile: false,
	controlNets: [],
	enlarge: 0
};
//#endregion
export { ParametersDefaults, PriorityChannel };
